import Icon from "@ant-design/icons/lib/components/Icon";

const multipleArrowsSvg = (...props) => {
    return (<svg
    viewBox="0 0 154.000000 154.000000"
    preserveAspectRatio="xMidYMid meet" width="1em" height="1em" fill="currentColor">
      <g transform="translate(0.000000,154.000000) scale(0.100000,-0.100000)"  stroke="none">
          <path d="M668 1323 c-102 -100 -115 -118 -97 -139 20 -25 42 -16 101 43 l58
          57 0 -380 0 -380 -32 -12 -33 -12 -265 265 -265 265 73 0 c80 0 112 11 112 38
          0 36 -20 42 -151 42 -103 0 -131 -3 -143 -16 -23 -23 -23 -265 0 -288 12 -12
          20 -13 35 -6 16 9 19 22 19 98 l0 87 269 -269 269 -269 -14 -33 c-30 -72 -4
          -160 62 -210 33 -25 46 -29 104 -29 58 0 71 4 104 29 106 81 93 249 -23 302
          l-40 19 -1 380 0 379 58 -57 c62 -61 85 -69 103 -36 10 19 1 31 -88 120 -55
          54 -105 99 -112 99 -8 0 -54 -39 -103 -87z m169 -888 c33 -22 49 -85 33 -126
          -15 -36 -63 -69 -100 -69 -37 0 -85 33 -100 70 -11 28 -11 39 1 74 24 69 101
          93 166 51z"/>
          <path d="M1233 1103 c-20 -7 -15 -51 6 -63 11 -5 53 -10 93 -10 l73 0 -194
          -194 c-198 -198 -217 -227 -162 -234 20 -3 59 31 218 190 l193 193 0 -87 c0
          -76 3 -89 19 -98 15 -7 23 -6 35 6 23 23 23 265 0 288 -12 13 -40 16 -142 15
          -70 0 -133 -3 -139 -6z"/>
      </g>
  </svg>)
}

const scatterPlot = (...props) => (<svg 
    xmlns="http://www.w3.org/2000/svg" version="1.1" 
    preserveAspectRatio="xMidYMid meet" width="1em" height="1em" fill="currentColor"
viewBox="0 0 225.000000 225.000000">
    <g transform="translate(0.000000,175.000000) scale(0.100000,-0.100000)"
    stroke="none">
        <path d="M90 1125 l0 -1035 1035 0 1035 0 0 115 0 115 -917 2 -918 3 -3 918
        -2 917 -115 0 -115 0 0 -1035z"/>
        <path d="M1760 1830 l0 -50 -50 0 -50 0 0 -45 0 -45 50 0 50 0 0 -45 0 -45 45
        0 45 0 0 45 0 45 45 0 45 0 0 45 0 45 -45 0 -45 0 0 50 0 50 -45 0 -45 0 0
        -50z"/>
        <path d="M1290 1480 l0 -50 -45 0 -45 0 0 -45 0 -45 45 0 45 0 0 -45 0 -45 45
        0 45 0 0 45 0 45 50 0 50 0 0 45 0 45 -50 0 -50 0 0 50 0 50 -45 0 -45 0 0
        -50z"/>
        <path d="M1690 1430 l0 -50 -45 0 -45 0 0 -45 0 -45 45 0 45 0 0 -45 0 -45 45
        0 45 0 0 45 0 45 50 0 50 0 0 44 0 45 -47 3 -48 3 -3 48 -3 47 -45 0 -44 0 0
        -50z"/>
        <path d="M868 1363 l-3 -48 -47 -3 -48 -3 0 -45 0 -44 50 0 50 0 0 -45 0 -45
        45 0 45 0 0 45 0 45 45 0 45 0 0 45 0 45 -45 0 -45 0 0 50 0 50 -44 0 -45 0
        -3 -47z"/>
        <path d="M1150 1095 l0 -45 -50 0 -50 0 0 -45 0 -45 50 0 50 0 0 -50 0 -50 45
        0 45 0 0 50 0 50 45 0 45 0 0 45 0 45 -45 0 -45 0 0 45 0 45 -45 0 -45 0 0
        -45z"/>
        <path d="M640 955 l0 -45 -45 0 -45 0 0 -45 0 -45 45 0 45 0 0 -50 0 -50 44 0
        45 0 3 48 3 47 48 3 47 3 0 45 0 44 -50 0 -50 0 0 45 0 45 -45 0 -45 0 0 -45z"/>
    </g>
</svg>)


const communitySvg = (...props) => (<svg 
    preserveAspectRatio="xMidYMid meet" width="1em" height="1em" fill="currentColor" viewBox="0 0 30.000000 30.000000"
>
    <g transform="translate(0.000000,30.000000) scale(0.100000,-0.100000)"
    stroke="none">
        <path d="M56 244 c-32 -32 -10 -94 34 -94 26 0 50 27 50 55 0 28 -24 55 -50
        55 -10 0 -26 -7 -34 -16z"/>
        <path d="M176 244 c-32 -32 -10 -94 34 -94 26 0 50 27 50 55 0 28 -24 55 -50
        55 -10 0 -26 -7 -34 -16z m59 -39 c0 -25 -4 -30 -25 -30 -16 0 -26 6 -28 18
        -6 30 6 49 30 45 18 -2 23 -9 23 -33z"/>
        <path d="M45 120 c-27 -10 -48 -36 -40 -50 9 -14 282 -14 291 1 3 6 -3 20 -14
        32 -18 18 -35 21 -119 23 -54 1 -107 -2 -118 -6z m215 -25 c24 -14 23 -14 -27
        -15 -49 0 -71 9 -56 24 11 11 57 6 83 -9z"/>
    </g>
</svg>)
  
const MultipleArrowsIcon = (props) => (<Icon component={multipleArrowsSvg} {...props} />);
const ScatterPlotIcon = (props) => (<Icon component={scatterPlot} {...props} />);
const CommunityIcon = (props) => (<Icon component={communitySvg} {...props} />);





export {MultipleArrowsIcon, ScatterPlotIcon, CommunityIcon}